export const transferStatus = {
  WAITING: 'waiting',
  PROCESSING: 'processing',
  FAILED: 'failed',
  TRANSFERRED: 'transferred',
  NO_TRANSFERRED: 'no_transferred',
  AUTO_TRANSFERRED: 'auto_transferred'
};
